'use client';

import Link from 'next/link';
import {
  MenuItem,
  MenuItemData,
} from '../../../../../../packages/ui/layout/app/left-sidebar/menu';
import { getLayoutStore } from '@wwe-portal/web/providers/stores/layout-store';
import { cn } from '@wwe-portal/ui/lib/lib';
import { usePathname } from 'next/navigation';
import { sendMenuClickEvent } from '@wwe-portal/web/libs/analytics/side-bar';

export const LeftSidebarMenuItem = ({
  item,
  extra,
  exact,
}: {
  item: MenuItemData;
  extra?: React.ReactNode;
  exact?: boolean;
}) => {
  const pathname = usePathname();
  return (
    <Link
      href={item.path}
      key={item.path}
      onClick={() => {
        getLayoutStore().getState().setSidebar('none');
        sendMenuClickEvent(item);
      }}
      className={cn('px-5 py-[5px] hover:no-underline', {
        'animate-background-up-down bg-[linear-gradient(45deg,_#1f233f,_#2a3165,_#1f233f)] [background-size:1000%]':
          item.isHightlighted,
      })}
    >
      <MenuItem
        isSelected={
          exact ? pathname === item.path : pathname.startsWith(item.path)
        }
        data={item}
        extra={extra}
      />
    </Link>
  );
};
